@if (error() && !toast() && (error().message || error().code)) {
<div role="alert" class="alert alert-danger">
  @if (error().message) {
  <span [ishServerHtml]="error().message"></span>
  } @else {
  <span [ishServerHtml]="error().code | translate"></span>
  }
</div>
}
